import OverflowActivityButton from 'crm-activity-creator-widgets/buttons/OverflowActivityButton';
import { useCardContextValue } from '../state/CardContext';
import { useHandleUpdateActivityButtons } from 'crm-activity-creator-widgets/hooks/useHandleUpdateActivityButtons';
import { useActiveTaskId } from '../hooks/useActiveTaskId';
import { useIsUngated } from 'crm-cards-sdk/hooks/useIsUngated';
import { gate } from 'hub-http/gates';
import { CreateActivityPermissionsContext } from 'crm-activity-creator-data/permission/CreateActivityPermissionsContext';
import { useCallback, useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { AuthProvider } from 'crm-activity-creator-data/auth/AuthContext';
import { useUserInfo } from '../hooks/useUserInfo';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DownCaratIcon } from 'foundations-assets/icons/components/DownCaratIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ButtonOverride = props => {
  return /*#__PURE__*/_jsxs(Button, Object.assign({}, props, {
    size: "xs",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "ObjectHighlightCard.miniCreateActivitiesButtonLabel"
    }), /*#__PURE__*/_jsx(DownCaratIcon, {})]
  }));
};
const MiniHighlightActivityButtons = () => {
  var _userInfo$gates, _userInfo$user$scopes, _subjectPermissionsRe, _subjectPermissionsRe2;
  const [buttonModal, setButtonModal] = useState(null);
  const {
    objectTypeId,
    objectId,
    asyncData: {
      orderedActivityButtonsResult,
      subjectPermissionsResult
    }
  } = useCardContextValue();
  const userInfo = useUserInfo();
  const {
    allActivityButtonsSorted,
    error,
    updateQuery
  } = orderedActivityButtonsResult;
  const {
    handleUpdateActivityButtons
  } = useHandleUpdateActivityButtons({
    updateQuery
  });
  const taskId = useActiveTaskId();
  const isUngatedToCallRemote = useIsUngated(gate('Calling:Rep:CRMRecordsRemote'));
  const handleOpenModal = useCallback(modal => {
    setButtonModal(modal);
  }, []);
  const handleCloseModal = useCallback(() => {
    setButtonModal(null);
  }, []);
  return /*#__PURE__*/_jsx(AuthProvider, {
    gates: (_userInfo$gates = userInfo === null || userInfo === void 0 ? void 0 : userInfo.gates) !== null && _userInfo$gates !== void 0 ? _userInfo$gates : [],
    scopes: (_userInfo$user$scopes = userInfo === null || userInfo === void 0 ? void 0 : userInfo.user.scopes) !== null && _userInfo$user$scopes !== void 0 ? _userInfo$user$scopes : [],
    children: /*#__PURE__*/_jsxs(CreateActivityPermissionsContext.Provider, {
      value: {
        currentUserCanCommunicate: (_subjectPermissionsRe = subjectPermissionsResult === null || subjectPermissionsResult === void 0 || (_subjectPermissionsRe2 = subjectPermissionsResult.data) === null || _subjectPermissionsRe2 === void 0 || (_subjectPermissionsRe2 = _subjectPermissionsRe2.crmObject) === null || _subjectPermissionsRe2 === void 0 || (_subjectPermissionsRe2 = _subjectPermissionsRe2.userPermissions) === null || _subjectPermissionsRe2 === void 0 ? void 0 : _subjectPermissionsRe2.currentUserCanCommunicate) !== null && _subjectPermissionsRe !== void 0 ? _subjectPermissionsRe : false
      },
      children: [/*#__PURE__*/_jsx(OverflowActivityButton, {
        allActivityButtons: allActivityButtonsSorted,
        objectId: String(objectId),
        objectTypeId: objectTypeId,
        buttonSize: "SM",
        enableReorder: true,
        maxVisible: 0,
        taskId: taskId,
        onUpdate: handleUpdateActivityButtons,
        useCallingWidget: !isUngatedToCallRemote,
        isError: !!error || !!subjectPermissionsResult.error,
        OverrideButtonComponent: ButtonOverride,
        onOpenModal: handleOpenModal,
        onCloseModal: handleCloseModal
      }), buttonModal]
    })
  });
};
export default MiniHighlightActivityButtons;